/**
 * Messages
 */
class Messages {
    constructor(userId, users, settings) {
        this.locked = false;
        this.texts = {};
        this.userId = 0;
        this.conversationId = 0;
        this.lastMessageId = 0;

        this.messagesConversation = null;
        this.messagesPanel = null;

        this.users = {};
        this.usersarr = [];

        this.shiftPressed = false;
        this.timeout = false;

        var that = this;

        this.userId = userId;
        this.texts = settings.texts;

        this.users = users;
        for (var i in this.users) {
            this.usersarr.push(this.users[i]);
        }

        this.initMessages();

        // Start the timeout
        this.timeout = setTimeout(function() {that.checkNew();}, 5000);
    }

    _lock() {
        //$("#conversation form textarea").attr("readonly", "readonly");
        //$("#search-input").attr("readonly", "readonly");
        this.locked = true;
    }

    _unlock() {
        //$("#conversation form textarea").attr("readonly", null);
        //$("#search-input").attr("readonly", null);
        this.locked = false;
    }

    initMessages() {
        var that = this;

        this.messagesConversation = $('section.conversation');
        this.messagesConversation.find('.messages-box').scroll(function() {
            var head = that.messagesConversation.find('div.head');
            $(this).scrollTop() ? head.addClass('shadow') : head.removeClass('shadow');
        });

        this.messagesPanel = $('section.panel');
        this.messagesPanel.find('ul').scroll(function() {
            var form = that.messagesPanel.find('form');
            $(this).scrollTop() ? form.addClass('shadow') : form.removeClass('shadow');
        })

        $(window).resize(function () {that.messagesResizeHandler();});
        this.messagesResizeHandler();

        //$('div.footer-fix, footer').css('display', 'none');

        $('#search-input').autocomplete({
            autoFocus: true,
            source: this.usersarr,
            select: function(event, ui) {
                $('#search-input').blur();
                window.setTimeout(function() {
                    $('#search-input').val('');
                    that.openConversation(ui.item.id);
                }, 10);
            }
        });

        $("#conversation form textarea").keydown(function(e) {
            var c = e.keyCode;

            if (c == 16) { // shift
                that.shiftPressed = true
            } else if (c == 13) { // enter
                if (!that.shiftPressed) {
                    e.preventDefault();
                }
            }
        });

        $("#conversation form textarea").keyup(function(e) {
            var c = e.keyCode;

            if (c == 16) { // shift
                that.shiftPressed = false
            } else if (c == 13) { // enter
                if (!that.shiftPressed) {
                    e.preventDefault();
                    that.sendMessage();
                }
            }
        });
    }

    messagesResizeHandler() {
        // var height = $(window).height();
        // var messagesBox = this.messagesConversation.find('.messages-box');

        // this.messagesConversation.css('height', height - 190);
        // messagesBox.css('height', 'auto');
        // if(messagesBox.height() > this.messagesConversation.height() - 141) messagesBox.css('height', this.messagesConversation.height() - 141);

        // this.messagesPanel.css('height', height - 190);
        // this.messagesPanel.find('ul').css('height', height - 240);
    }

    _showConversation() {
        $("#conversation .message").css("display", "none");
        $("#conversation .head").css("display", "block");
        $("#conversation .messages-box").css("display", "block").html("");
        $("#conversation form").css("display", "block");
    }

    openConversation(userId) {
        if (parseInt(userId) == parseInt(this.conversationId)) return;
        if (this.locked) return;

        var that = this;
        this._lock();

        var imgSrc = this.users[userId].img;
        var name = this.users[userId].label;

        if ($("#conversation .messages-box").css("display") == "none") {
            this._showConversation();
        }

        $("#users li a").removeClass("active");
        $("#user-" + userId + " a").addClass("active");
        $("#conversation .head .image img").attr("src", imgSrc);
        $("#conversation .name").html(name);
        $("#conversation .head a").attr('href', this.users[userId].url);

        this.conversationId = userId;
        this.lastMessageId = 0;
        $("#conversation .messages-box").html('');
        $("#conversation form textarea").val('').focus();

        $("#user-" + userId + " .count").fadeOut(300, function() {
            $("#user-" + userId + " .count").text('');
        });

        if (parseInt(this.users[userId].messages) > 0) {
            $.ajax({
                url: "/messages/conversation/", dataType: 'json', type: 'post',
                data: {user_id: userId},
                success: function(data) {
                    if (data && data.success != undefined && data.success) {
                        $("#conversation .messages-box").html(data.messages);
                        that.lastMessageId = data.lastMessageId;
                        that._unlock();
                        that.messagesResizeHandler();

                        $('#conversation .messages-box').scrollTop($('#conversation .messages-box').get(0).scrollHeight);
                    } else {
                        that._unlock();
                    }
                }
            });
        } else {
            that._unlock();
        }
    }

    updateConversation() {
        if (this.locked) return;

        var that = this;
        this._lock();

        $.ajax({
            url: "/messages/conversation/", dataType: 'json', type: 'post',
            data: {user_id: this.conversationId, 'offset': this.lastMessageId},
            success: function(data) {
                if (data && data.success != undefined && data.success) {
                    $("#conversation .messages-box").append(data.messages);
                    that.lastMessageId = data.lastMessageId;
                    that._unlock();
                    that.messagesResizeHandler();
                    $('#conversation .messages-box').scrollTop($('#conversation .messages-box')[0].scrollHeight);
                } else {
                    that._unlock();
                }
            }
        });
    }

    sendMessage() {
        var text = $("#conversation form textarea", this.messageModal).val();
        if (!text.length) return;

        var that = this;

        $.ajax({
            url: "/messages/send/",
            dataType: 'json',
            type: 'post',
            data: {user_id: this.conversationId, text: text, get: 1},
            success: function(data) {
                $("#conversation form textarea").val('');

                if (data && data.success != undefined && data.success) {
                    $("#conversation .messages-box").append(data.message);
                    that.lastMessageId = data.message_id;

                    var l = $("#user-" + that.conversationId);
                    if (!l || !l.length) {
                        // no li, create one

                        var imgSrc = "/img/web/default-avatar-small.jpg";
                        if (that.users[that.conversationId].img) {
                            imgSrc = this.users[that.conversationId].img.replace("-medium.jpg", "").replace("-big.jpg", "").replace("-small.jpg", "") + "-small.jpg";
                        }
                        var name = that.users[that.conversationId].label;

                        var html  = '<li id="user-' + that.conversationId + '">';
                            html += '<a href="#" class="active">';
                            html += '<img alt="" src="' + imgSrc + '" />';
                            html += '<strong>' + name + '</strong>';
                            html += '<span class="text">' + text.substr(0, 20) + (text.length > 20 ? '...' : '') + '</span>';
                            html += '<span class="count" style="display: none;"></span>';
                            html += '</a>';
                            html += '</li>';

                        $("#users").prepend(html);
                    } else {
                        $("#user-" + that.conversationId + " .text").text(text.substr(0, 20) + (text.length > 20 ? '...' : ''));
                        $("#users").prepend($("#user-" + that.conversationId).detach());
                    }

                    that._unlock();
                    that.messagesResizeHandler();
                    $('#conversation .messages-box').scrollTop($('#conversation .messages-box')[0].scrollHeight);
                } else {
                    that._unlock();
                }
            }
        });
    }

    checkNew() {
        var that = this;

        $.ajax({
            url: "/messages/check/",
            dataType: 'json',
            type: 'post',
            data: {search: $("#search-input").val(), selected: this.conversationId},
            success: function(data) {
                if (data && data.success != undefined && data.success) {
                    $("#users li .count").text('').hide();
                    for (var uid in data.messages) {
                        //that.users[uid].lastMessageId = data.messages[uid][1];
                        that.users[uid].lastMessage = data.messages[uid][2];
                        $("#user-" + uid + " .text").text(data.messages[uid][2].substr(0, 20) + (data.messages[uid][2].length > 20 ? '...' : ''));
                        $("#users").prepend($("#user-" + uid).detach());

                        if (parseInt(uid) == parseInt(that.conversationId)) {
                            that.updateConversation();
                        } else {
                            $("#user-" + uid + " .count").text(data.messages[uid][0]).show();
                        }
                    }
                }

                that.timeout = setTimeout(function() {that.checkNew();}, 5000);
            }
        });
    }
}

export { Messages }
